export default "__VITE_ASSET__853ec57d__"